import millify from 'millify';

const artificialOptions = ['Combined data', 'Client Side Prebid', 'Server Side Prebid'];

const filterDataByBidder = (decilesData, selectedBidder) => {
  let filteredData;
  if (selectedBidder === 'Combined data' || selectedBidder === 'bidder') {
    filteredData = decilesData;
  } else if (selectedBidder === 'Client Side Prebid') {
    filteredData = decilesData.filter(row => !row.bidder.toLowerCase().includes('s2s'));
  } else if (selectedBidder === 'Server Side Prebid') {
    filteredData = decilesData.filter(row => row.bidder.toLowerCase().includes('s2s'));
  } else {
    filteredData = decilesData.filter(row => row.bidder === selectedBidder);
  }

  return filteredData;
};

export const calculateDecilesDataForGraph = (
  decilesData,
  selectedBidder = 'bidder',
  intervalsMode = 0
) => {
  let googleData = [];

  decilesData.forEach(row => {
    googleData.push({
      bidder: row.Dimension.CUSTOM_CRITERIA.split('=')[1].toLowerCase(),
      imp: row.Column.TOTAL_LINE_ITEM_LEVEL_IMPRESSIONS,
      eCPM: parseFloat(row.Column.TOTAL_LINE_ITEM_LEVEL_WITHOUT_CPD_AVERAGE_ECPM) / 1000000,
      revenue:
        parseFloat(
          row.Column?.TOTAL_LINE_ITEM_LEVEL_CPM_AND_CPC_REVENUE ||
            row.TOTAL_LINE_ITEM_LEVEL_CPM_AND_CPC_REVENUE ||
            0
        ) / 1000000,
    });
  });

  // Sort data by eCPM
  googleData.sort((a, b) => (a.eCPM > b.eCPM ? 1 : -1));

  let totalImpressionsFiltered = filterDataByBidder(googleData, selectedBidder).reduce(
    (sum, eCPM) => parseFloat(eCPM.imp) + sum,
    0
  );

  let totalRevenueFiltered = filterDataByBidder(googleData, selectedBidder).reduce(
    (sum, eCPM) => parseFloat(eCPM.revenue) + sum,
    0
  );

  // Get decile impression ammount
  let decileImpressionAmmount = totalImpressionsFiltered / 10;

  let decileRanges = {};
  let impressionsInRage = 0;
  let currentDecileRange = 0;
  let lastCPM = {
    eCPM: 0,
  };

  let fixedIntervals = [0.01, 0.1, 1, 10]
    .map(start => {
      let generatedRanges = [];
      for (let step = 1; step < 10; step++) {
        generatedRanges.push(start * step);
      }
      return [...generatedRanges];
    })
    .flat();
  fixedIntervals.unshift(0);

  //Generate periods if fixed intervals mode
  if (intervalsMode === 1) {
    // Reset for fixed intervals mode
    currentDecileRange = 0;

    fixedIntervals.map((price, i) => {
      decileRanges[i] = [
        {
          eCPM: {
            eCPM: price.toFixed(2),
            imp: '0',
            revenue: 0,
          },
        },
      ];
    });

    decileRanges[fixedIntervals.length] = [
      {
        eCPM: {
          eCPM: 100,
          imp: '0',
          revenue: 0,
        },
      },
    ];
  }

  filterDataByBidder(googleData, selectedBidder).map(eCPM => {
    if (intervalsMode === 1) {
      // Find the correct interval for this eCPM value
      while (
        currentDecileRange < fixedIntervals.length &&
        fixedIntervals[currentDecileRange] < eCPM.eCPM
      ) {
        currentDecileRange = currentDecileRange + 1;
      }

      // Ensure we don't exceed the available ranges
      if (currentDecileRange >= Object.keys(decileRanges).length) {
        currentDecileRange = Object.keys(decileRanges).length - 1;
      }

      decileRanges[currentDecileRange].push({
        eCPM,
      });
    }

    if (intervalsMode === 0) {
      if (
        impressionsInRage + parseInt(eCPM.imp) <= decileImpressionAmmount ||
        eCPM.eCPM === lastCPM.eCPM
      ) {
        // Create new range if doesnt exist
        if (!decileRanges[currentDecileRange]) {
          decileRanges[currentDecileRange] = [];
        }

        // Add to same decile range
        impressionsInRage = impressionsInRage + parseInt(eCPM.imp);

        decileRanges[currentDecileRange].push({
          eCPM,
        });
      } else {
        // Move to another decile range
        impressionsInRage = 0;
        currentDecileRange = currentDecileRange + 1;

        // Add to same decile range
        impressionsInRage = impressionsInRage + parseInt(eCPM.imp);

        // Create new range if doesnt exist
        if (!decileRanges[currentDecileRange]) {
          decileRanges[currentDecileRange] = [];
        }

        decileRanges[currentDecileRange].push({
          eCPM,
        });
      }

      lastCPM = eCPM;
    }
  });

  let decilesDataForGraph = [];

  Object.keys(decileRanges).map(range => {
    let currentRange = parseInt(range);
    let nextRange = currentRange + 1;

    let imp;
    let rev;
    let totalIntervalRevenue;

    if (intervalsMode === 1) {
      imp = filterDataByBidder(googleData, selectedBidder)
        .filter(
          eCPM =>
            eCPM.eCPM >= decileRanges[currentRange][0].eCPM.eCPM &&
            eCPM.eCPM <= decileRanges[nextRange][0].eCPM.eCPM
        )
        .reduce((sum, rangeData) => parseInt(rangeData.imp) + sum, 0);

      rev = filterDataByBidder(googleData, selectedBidder)
        .filter(
          eCPM =>
            eCPM.eCPM >= decileRanges[currentRange][0].eCPM.eCPM &&
            eCPM.eCPM <= decileRanges[nextRange][0].eCPM.eCPM
        )
        .reduce((sum, rangeData) => parseFloat(rangeData.revenue) + sum, 0);

      totalIntervalRevenue = googleData
        .filter(
          eCPM =>
            eCPM.eCPM >= decileRanges[currentRange][0].eCPM.eCPM &&
            eCPM.eCPM <= decileRanges[nextRange][0].eCPM.eCPM
        )
        .reduce((sum, rangeData) => parseFloat(rangeData.revenue) + sum, 0);
    }

    if (intervalsMode === 0) {
      imp = decileRanges[currentRange].reduce(
        (sum, rangeData) => parseInt(rangeData.eCPM.imp) + sum,
        0
      );

      rev = decileRanges[currentRange].reduce(
        (sum, rangeData) => parseFloat(rangeData.eCPM.revenue) + sum,
        0
      );
    }

    decilesDataForGraph.push({
      revShare: `${((rev * 100) / totalRevenueFiltered).toFixed(2)}%`,
      impShare: `${((imp * 100) / totalImpressionsFiltered).toFixed(2)}%`,
      imp: imp,
      revenue: rev,
      totalIntervalRevenue: totalIntervalRevenue,
      eCPM: decileRanges[currentRange][0].eCPM.eCPM,
      eCPMrange: `${decileRanges[currentRange][0].eCPM.eCPM} ${
        decileRanges[nextRange]
          ? `- ${decileRanges[nextRange][0].eCPM.eCPM}`
          : `- ${decileRanges[currentRange][decileRanges[currentRange].length - 1].eCPM.eCPM}`
      }`,
    });
  });

  return decilesDataForGraph;
};

export const calculateCumulativeDistributionData = (
  decilesData,
  calculateBidder = 'bidder',
  CPM
) => {
  let googleData = [];

  // Handle artificial options
  let filteredData;
  if (calculateBidder === 'Combined data' || calculateBidder === 'bidder') {
    filteredData = decilesData;
  } else if (calculateBidder === 'Client Side Prebid') {
    filteredData = decilesData.filter(row => {
      let bidder = row.Dimension.CUSTOM_CRITERIA.split('=')[1];
      return !bidder.toLowerCase().includes('s2s');
    });
  } else if (calculateBidder === 'Server Side Prebid') {
    filteredData = decilesData.filter(row => {
      let bidder = row.Dimension.CUSTOM_CRITERIA.split('=')[1];
      return bidder.toLowerCase().includes('s2s');
    });
  } else {
    filteredData = decilesData.filter(row => {
      let bidder = row.Dimension.CUSTOM_CRITERIA.split('=')[1];
      return bidder === calculateBidder;
    });
  }

  filteredData.map(row => {
    googleData.push({
      imp: row.Column.TOTAL_LINE_ITEM_LEVEL_IMPRESSIONS,
      eCPM: parseFloat(row.Column.TOTAL_LINE_ITEM_LEVEL_WITHOUT_CPD_AVERAGE_ECPM) / 1000000,
      revenue:
        parseFloat(
          row.Column?.TOTAL_LINE_ITEM_LEVEL_CPM_AND_CPC_REVENUE ||
            row.TOTAL_LINE_ITEM_LEVEL_CPM_AND_CPC_REVENUE ||
            0
        ) / 1000000,
    });
  });

  // Sort by eCPM
  googleData.sort((a, b) => parseFloat(a.eCPM) - parseFloat(b.eCPM));

  // Get total impressions and revenue
  let totalImpressions = googleData.reduce((sum, eCPM) => parseInt(eCPM.imp) + sum, 0);
  let totalRevenue = googleData.reduce((sum, eCPM) => parseFloat(eCPM.revenue) + sum, 0);

  let decileRanges = {};
  let impressionsInRage = 0;
  let currentDecileRange = 0;
  let lastCPM = {
    eCPM: 0,
  };

  googleData.map(eCPM => {
    if (parseFloat(eCPM.eCPM) < parseFloat(CPM) || currentDecileRange === 1) {
      // Add to same decile range
      // Create new range if doesnt exist
      if (!decileRanges[currentDecileRange]) {
        decileRanges[currentDecileRange] = [];
      }

      impressionsInRage = impressionsInRage + parseInt(eCPM.imp);

      decileRanges[currentDecileRange].push({
        eCPM,
      });
    } else {
      // Move to another decile range
      impressionsInRage = 0;
      currentDecileRange = currentDecileRange + 1;

      // Add to same decile range
      impressionsInRage = impressionsInRage + parseInt(eCPM.imp);

      // Create new range if doesnt exist
      if (!decileRanges[currentDecileRange]) {
        decileRanges[currentDecileRange] = [];
      }

      decileRanges[currentDecileRange].push({
        eCPM,
      });
    }

    lastCPM = eCPM;
  });

  let decilesDataForGraph = [];
  Object.keys(decileRanges).map(range => {
    let currentRange = parseInt(range);
    let nextRange = currentRange + 1;

    let imp = decileRanges[currentRange].reduce(
      (sum, rangeData) => parseInt(rangeData.eCPM.imp) + sum,
      0
    );
    let rev = decileRanges[currentRange].reduce(
      (sum, rangeData) => parseFloat(rangeData.eCPM.revenue) + sum,
      0
    );

    decilesDataForGraph.push({
      imp: imp,
      revenue: rev,
      maxInRange: decileRanges[currentRange][decileRanges[currentRange].length - 1].eCPM.eCPM,
      debug: [decileRanges[currentRange]],
      rangeStart: decileRanges[currentRange][0].eCPM.eCPM,
      eCPMrange: `${decileRanges[currentRange][0].eCPM.eCPM} ${
        decileRanges[nextRange] ? `- ${decileRanges[nextRange][0].eCPM.eCPM}` : `<`
      }`,
      eCPMrangeForPies: `eCPM ${decileRanges[currentRange][0].eCPM.eCPM}  ${
        decileRanges[nextRange]
          ? `- ${decileRanges[nextRange][0].eCPM.eCPM}€`
          : `- ${decileRanges[currentRange][decileRanges[currentRange].length - 1].eCPM.eCPM}€`
      }\nRevenue ${rev.toFixed(0)}€ (${((rev * 100) / totalRevenue).toFixed(
        0
      )}%)\nImpressions ${millify(imp)} (${((imp * 100) / totalImpressions).toFixed(0)}%)`,
    });
  });

  return decilesDataForGraph;
};

export const extractBiddersFromData = data => {
  // First, collect all bidders from the actual data
  let biddersFromData = [];
  data.map(row => {
    let bidder = row.Dimension.CUSTOM_CRITERIA.split('=')[1];
    if (!biddersFromData.includes(bidder)) {
      biddersFromData.push(bidder);
    }
  });

  // Add bidders from directSSPCodeAndAlias only if they exist in the data
  return artificialOptions.concat(biddersFromData);
};
